(function ($) {
  const initHomePushItemHeight = () => {

    let maxHeight = 0
    let titleHeight = 0
    $(".homepage-push-carousel-item > div .content .description").each((index, element) => {
      maxHeight = element.scrollHeight > maxHeight ? element.scrollHeight : maxHeight
      titleHeight = $(element).parent().find(".title").outerHeight() > titleHeight ? $(element).parent().find(".title").outerHeight() : titleHeight
    })

    $(".homepage-push-carousel-item > div").css("--height", maxHeight + "px")
    $(".homepage-push-carousel-item > div").css("--title-height", titleHeight + "px")
  }

  $(document).ready(() => {

    if ($("#homepage-push-carousel").length === 0)
      return;

    $('#homepage-push-carousel').each(function () {
      tns({
        "container": this,
        "swipeAngle": false,
        "speed": 400,
        "navPosition": "bottom",
        "mouseDrag": true,
        "controlsText": ["précédent", "suivant"],
        onInit: initHomePushItemHeight,
        responsive: {
          1200: {
            "disable": true
          }
        }
      })
    });

    $(window).on("resize", initHomePushItemHeight)

  })
})(jQuery);
